/* Blessac store menu — simple version (anh 24/10; design: plans/261023-1632-menu-minimal-preview).
   Desktop: Bags · Wallets · Bag Charms · Bible & Journals · Shop by Verse (+ Our Story link). Resting the
   pointer on an item or clicking it opens its panel: category tiles in "Ready to ship" / "Pre-order" rows,
   three popular picks, one legend line. Phone: one screen; each department opens in place as a picture grid.
   Every tile and product says In stock or Pre-order, read live from the store's pre-order tags.
   Data loads only when the shopper reaches for the menu (or the browser is idle):
     blessac-menu-v4.json            departments, tiles, images, product facts (menu-src/build_theme_menu.py)
     ?section_id=blessac-menu-live   live order, counts and pre-order status of the menu collections. */

const CFG = document.querySelector('[data-bm4-json]');
if (CFG && !window.__bm4) {
  window.__bm4 = true;
  init(CFG.dataset);
}

function init(cfg) {
  const ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const ASSETS = cfg.bm4Json.replace(/[^/]*$/, '');
  const VER = (cfg.bm4Json.match(/\?v=\d+/) || [''])[0];
  const PAGES = { track: 'pages/track-order', returns: 'pages/return-refund', contact: 'pages/contact', story: 'pages/our-story',
    'journal-clearance': 'pages/prayer-journal-b1g2-clearance' };
  const ICON = {
    search: '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg>',
    x: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg>',
    bag: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 8h14l-1 13H6L5 8Z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/></svg>',
  };
  const esc = s => String(s ?? '').replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

  /* ---------- links ---------- */
  const U = {
    col: h => `${ROOT}collections/${h}`,
    prod: h => `${ROOT}products/${h}`,
    page: k => ROOT + PAGES[k],
    search: q => `${ROOT}search?q=${encodeURIComponent(q)}&type=product&options%5Bprefix%5D=last`,
  };
  const DEAL_KINDS = new Set(['Prayer Journal']);          // the B1G2 price only exists on the deal page
  const hrefOf = it => DEAL_KINDS.has(it.kind) ? U.page('journal-clearance') : U.prod(it.h);
  const hrefTile = t => t.href ? U.page(t.href) : U.col(t.col);

  /* ---------- data ---------- */
  let D = null, loading = null;
  const livePO = new Set(), liveSeen = new Set();
  function PR(h) {
    const p = D.products[h] || (D.liveP[h] && { h, name: D.liveP[h][0], ref: '', kind: '', po: !!D.liveP[h][2], photo: D.liveP[h][1] });
    if (p && liveSeen.has(h)) p.po = livePO.has(h);        // the store's pre-order tag today wins over build-time data
    return p;
  }
  const itemsOf = h => { const c = D.collections[h]; return c ? (c.live || c.items).filter(PR) : []; };
  /* a tile's counts: live when the store answered, else the build-time numbers */
  function stat(t) {
    const c = D.collections[t.col];
    const n = c && c.live ? c.n : t.n, q = c && c.live ? Math.min(c.q, c.n) : t.q;
    return { n, q, kind: q === 0 ? 'in' : q >= n ? 'po' : 'mix' };
  }

  function ensureCss() {
    if (document.querySelector('link[data-bm4-css]')) return;
    const l = document.createElement('link');
    l.rel = 'stylesheet'; l.href = cfg.bm4Css; l.dataset.bm4Css = '';
    document.head.appendChild(l);
  }
  function parseLive(html) {
    const m = html && html.match(/<script type="application\/json" data-bm4-live>([\s\S]*?)<\/script>/);
    try { return m ? JSON.parse(m[1]) : null; } catch (e) { return null; }
  }
  function load() {
    if (loading) return loading;
    ensureCss();
    const live = fetch(`${ROOT}?section_id=blessac-menu-live`, { credentials: 'same-origin' }).then(r => (r.ok ? r.text() : '')).catch(() => '');
    loading = Promise.all([fetch(cfg.bm4Json).then(r => r.json()), live]).then(([d, html]) => {
      const lv = parseLive(html) || { c: {}, p: {} };
      d.liveP = lv.p || {};
      for (const [h, c] of Object.entries(lv.c || {})) {
        if (!d.collections[h]) d.collections[h] = { title: h, items: [], page: true };
        Object.assign(d.collections[h], { live: c.p, n: c.n, q: c.q || 0 });
        c.p.forEach(x => liveSeen.add(x));
        (c.x || []).forEach(x => livePO.add(x));
      }
      D = d;
      return d;
    });
    loading.catch(() => { loading = null; });
    return loading;
  }

  /* ---------- pictures + tags ---------- */
  const sized = (url, w) => /cdn\.shopify\.com|\/cdn\/shop\//.test(url) ? url.replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, '') + (url.includes('?') ? '&' : '?') + 'width=' + w : url;
  function ph(src, w = 360) {
    if (!src) return '<span class="ph"></span>';
    const photo = /^https?:|^\/\//.test(src);
    return `<span class="ph${photo ? ' ph--photo' : ''}"><img src="${esc(photo ? sized(src, w) : ASSETS + src + VER)}" alt="" decoding="async"></span>`;
  }
  const pimg = it => ph(it.po && it.feat ? it.feat : it.img || it.photo || it.feat);
  const TAG = { in: '<b class="tag tag--in">In stock</b>', po: '<b class="tag tag--po">Pre-order</b>' };
  const LEGEND = `<span>${TAG.in} Ships from the USA in 4–6 days</span><span>${TAG.po} Made to order for you — we email you when it ships</span>`;

  /* ---------- desktop panel ---------- */
  function tile(t) {
    const s = stat(t);
    const meta = t.deal ? '<span class="tile__deal">Buy 1, Get 2 Free</span>' : `${s.n} design${s.n === 1 ? '' : 's'}${s.kind === 'mix' ? ` · ${s.q} pre-order` : ''}`;
    return `<a class="tile" href="${hrefTile(t)}" data-hc-el="menu-style"><span class="tile__img">${ph(t.img)}<span class="tile__tags">${s.kind === 'po' ? TAG.po : TAG.in}</span></span>
      <span class="tile__t">${esc(t.label)}</span><span class="tile__m">${meta}</span></a>`;
  }
  /* popular picks: the shelf's own order (most stock first), keeping one pre-order piece in view when it has one */
  function picks(col, n = 3) {
    const it = itemsOf(col), ins = it.filter(h => !PR(h).po), pos = it.filter(h => PR(h).po);
    return (pos.length && ins.length ? ins.slice(0, n - 1).concat(pos.slice(0, 1)) : it.slice(0, n));
  }
  function card(h) {
    const p = PR(h), sub = [p.ref, p.kind].filter(Boolean).join(' · ');
    return `<a class="card" href="${hrefOf(p)}" data-hc-el="menu-product">${pimg(p)}<span class="card__t">${esc(p.name)}</span>
      <span class="card__m">${esc(sub)}</span>${p.po ? TAG.po : TAG.in}</a>`;
  }
  const legend = () => `<div class="legend"><div>${LEGEND}<span class="legend__r">30-day easy returns</span></div></div>`;
  function panelHtml(dp) {
    if (dp.verses) {
      return `<div class="sp sp--wide"><p class="sp__lede">Every piece carries a verse. Pick the one that speaks to you — or to someone you love.</p>
        <div class="verses">${dp.verses.map(v => `<a class="verse" href="${U.col(v.col)}" data-hc-el="menu-verse">${ph(v.img)}<span><b>${esc(v.name)}</b><small>${esc(v.ref)}</small></span></a>`).join('')}</div></div>${legend()}`;
    }
    let left = '';
    if (dp.hero) {
      const c = dp.hero, n = (D.collections[c.col] || {}).n || itemsOf(c.col).length;
      left = `<a class="hero" href="${U.col(c.col)}" data-hc-el="menu-craft">${ph(c.macro, 700)}<span>${TAG.po}<strong>${esc(c.name)}</strong><em>${esc(c.line)}</em><i>See all ${n} charms →</i></span></a>`;
    }
    if (dp.ready && dp.ready.length) left += `<p class="sp__h"><b class="dot dot--in"></b>Ready to ship</p><div class="tiles">${dp.ready.map(tile).join('')}</div>`;
    if (dp.pre && dp.pre.length) left += `<p class="sp__h"><b class="dot dot--po"></b>Pre-order · new designs, made to order</p><div class="tiles">${dp.pre.map(tile).join('')}</div>`;
    const right = `<p class="sp__h">Popular picks</p><div class="cards">${picks(dp.picks, dp.npicks || 3).map(card).join('')}</div>
      <a class="sp__all" href="${U.col(dp.all[1])}" data-hc-el="menu-line">${esc(dp.all[0])} →</a>`;
    return `<div class="sp"><div class="sp__l">${left}</div><div class="sp__r">${right}</div></div>${legend()}`;
  }

  /* ---------- search: verse-aware autosuggest ("ps 23", "prov 3 5") ---------- */
  const BOOKS = { ps: 'psalm', psa: 'psalm', psalms: 'psalm', prov: 'proverbs', pr: 'proverbs', phil: 'philippians', php: 'philippians', jer: 'jeremiah',
    isa: 'isaiah', is: 'isaiah', rom: 'romans', josh: 'joshua', jos: 'joshua', matt: 'matthew', mt: 'matthew', jn: 'john', deut: 'deuteronomy', tim: 'timothy' };
  const norm = s => s.toLowerCase().replace(/[^a-z0-9: ]+/g, ' ').replace(/(\d+)\s*[: ]\s*(\d+)/g, '$1:$2').split(/\s+/).filter(Boolean).map(w => BOOKS[w] || w);
  function find(q, limit = 6) {
    const words = norm(q); if (!words.length) return null;
    return Object.values(D.products).map(it => ({ it, hay: norm(`${it.name} ${it.ref} ${it.kind}`) }))
      .filter(x => words.every(w => x.hay.some(h => h.startsWith(w))))
      .sort((a, b) => (b.hay[0].startsWith(words[0]) - a.hay[0].startsWith(words[0])) || a.it.name.localeCompare(b.it.name))
      .slice(0, limit).map(x => PR(x.it.h));
  }
  function sugHtml(q, list) {
    const re = new RegExp('\\b(' + norm(q).map(w => w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|') + ')', 'gi');
    const hl = s => esc(s).replace(re, '<mark>$1</mark>');
    if (!list.length) return `<p class="none">No match for “${esc(q)}”. Try a verse like Psalm 46:10.</p>`;
    return list.map(it => `<a href="${hrefOf(it)}" role="option" data-hc-el="menu-search-pick">${pimg(it)}<span>${hl(it.name)} ${esc(it.kind)}<small>${hl(it.ref || it.kind)}</small></span></a>`).join('')
      + `<a class="all" href="${U.search(q)}" data-hc-el="menu-search-all">See all results for “${esc(q)}” →</a>`;
  }
  function wireSearch(root) {
    const inp = root.querySelector('.msearch input'), sug = root.querySelector('.msearch .sug');
    if (!inp) return;
    const run = () => { const q = inp.value.trim(), list = find(q); sug.classList.toggle('is-open', !!list); if (list) sug.innerHTML = sugHtml(q, list); };
    inp.addEventListener('input', run);
    inp.addEventListener('focus', run);
  }

  /* ---------- desktop controller: hover or click opens, never jumps to a collection page ---------- */
  const header = document.querySelector('#header-component');
  const navEl = document.querySelector('.bm4nav');
  const panel = document.querySelector('.bm4panel');
  const scrim = document.querySelector('.bm4scrim');
  const desk = { open: false, id: null, timer: null };
  if (panel) document.body.append(panel, scrim);           // out of the sticky header so position:fixed is the viewport
  const navItems = () => navEl ? [...navEl.querySelectorAll('[data-m]')] : [];
  const dept = id => D.simple.find(d => d.id === id);

  function placePanel() {
    const top = Math.max(0, Math.round((header || navEl).getBoundingClientRect().bottom));
    panel.style.setProperty('--bm4-top', top + 'px');
    scrim.style.setProperty('--bm4-top', top + 'px');
  }
  function setExpanded() { navItems().forEach(b => b.setAttribute('aria-expanded', String(desk.open && b.dataset.m === desk.id))); }
  function openPanel(id) {
    clearTimeout(desk.timer);
    if (!D) {
      desk.want = id;
      load().then(() => { if (desk.want === id) openPanel(id); }).catch(() => {});
      return;
    }
    if (!dept(id)) return;
    if (id !== desk.id || !panel.firstElementChild) {
      desk.id = id;
      panel.innerHTML = panelHtml(dept(id));
    }
    placePanel();
    if (!desk.open) {                       // the click that follows a hover-open must not close it again
      desk.justOpened = true;
      setTimeout(() => { desk.justOpened = false; }, 700);
    }
    panel.hidden = false; scrim.hidden = false;
    desk.open = true; setExpanded();
  }
  function closePanel() {
    clearTimeout(desk.timer);
    desk.want = null;
    if (!desk.open) return;
    desk.open = false; panel.hidden = true; scrim.hidden = true; setExpanded();
  }
  const closeSoon = (ms = 280) => { clearTimeout(desk.timer); desk.timer = setTimeout(closePanel, ms); };

  if (navEl && panel) {
    /* Resting the pointer on an item opens its panel (anh 21/10, like Afroyla). After a click closed it,
       the same item stays shut until the pointer leaves it, so the chevron under the cursor cannot reopen it. */
    navEl.addEventListener('mouseover', e => {
      const b = e.target.closest('.bm4nav__i'); if (!b) return;
      if (b.dataset.m && b.dataset.m === desk.shut) return;
      clearTimeout(desk.timer);
      if (b.dataset.m) desk.timer = setTimeout(() => openPanel(b.dataset.m), desk.open ? 0 : 110);
      else if (desk.open) closeSoon(80);
    });
    navEl.addEventListener('mouseout', e => {
      const b = e.target.closest('.bm4nav__i');
      if (b && b.dataset.m === desk.shut && !b.contains(e.relatedTarget)) desk.shut = null;
    });
    navEl.addEventListener('pointerenter', () => load().catch(() => {}), { once: true });
    /* A click on a menu item (label or chevron) toggles its panel, it never jumps to a collection page (anh 8/10);
       the click that lands right after a hover-open keeps it open. The href only serves shoppers without JS. */
    navEl.addEventListener('click', e => {
      const b = e.target.closest('[data-m]'); if (!b) return;
      e.preventDefault();
      if (desk.open && desk.id === b.dataset.m && !desk.justOpened) { closePanel(); desk.shut = b.dataset.m; }
      else { desk.shut = null; openPanel(b.dataset.m); }
    });
    navEl.addEventListener('keydown', e => {
      const b = e.target.closest('[data-m]'); if (!b) return;
      if (e.key === 'ArrowDown' || e.key === ' ') {
        e.preventDefault(); openPanel(b.dataset.m);
        const go = () => { const f = panel.querySelector('a'); if (f) f.focus(); };
        D ? go() : load().then(() => setTimeout(go, 0));
      }
    });
    (header || navEl).addEventListener('mouseleave', e => { if (!panel.contains(e.relatedTarget)) closeSoon(); });
    panel.addEventListener('mouseenter', () => clearTimeout(desk.timer));
    panel.addEventListener('mouseleave', e => { if (!(header || navEl).contains(e.relatedTarget)) closeSoon(); });
    scrim.addEventListener('mouseenter', () => closeSoon(160));
    scrim.addEventListener('click', closePanel);
    panel.addEventListener('focusout', e => { if (!panel.contains(e.relatedTarget) && !navEl.contains(e.relatedTarget)) closeSoon(120); });
    document.addEventListener('keydown', e => {
      if (e.key !== 'Escape' || !desk.open) return;
      const id = desk.id; desk.timer = null;
      if (document.activeElement) document.activeElement.blur();
      closePanel();
      const b = navItems().find(x => x.dataset.m === id); if (b) b.focus();
    });
    window.addEventListener('scroll', () => { if (desk.open) placePanel(); }, { passive: true });
    window.addEventListener('resize', () => { if (desk.open) placePanel(); });
  }

  /* ---------- phone drawer: one screen, each department opens in place as a picture grid ---------- */
  const btn = document.querySelector('.bm4btn');
  const drawerEl = document.querySelector('.bm4drawer');
  const drawer = { open: false };
  if (drawerEl) document.body.append(drawerEl);
  function cell(label, href, src, sub = '', deal = false) {
    return `<a class="mcell" href="${href}" data-hc-el="menu-style">${ph(src, 300)}<span class="mcell__t">${esc(label)}</span>${sub ? `<small${deal ? ' class="deal"' : ''}>${esc(sub)}</small>` : ''}</a>`;
  }
  function deptBody(dp) {
    if (dp.verses) return `<div class="mgrid">${dp.verses.map(v => cell(v.name, U.col(v.col), v.img, v.ref)).join('')}</div>`;
    let out = '';
    for (const [title, dot, rows] of [['Ready to ship', 'in', dp.ready], ['Pre-order · made to order', 'po', dp.pre]]) {
      if (!rows || !rows.length) continue;
      out += `<p class="mgrp"><b class="dot dot--${dot}"></b>${title}</p><div class="mgrid">${rows.map(t => cell(t.label, hrefTile(t), t.img, t.deal ? 'Buy 1, Get 2 Free' : '', !!t.deal)).join('')}</div>`;
    }
    return out + `<a class="mall" href="${U.col(dp.all[1])}" data-hc-el="menu-line">${esc(dp.all[0])} →</a>`;
  }
  function deptRow(dp) {
    const thumb = dp.thumb || (dp.ready && dp.ready[0] ? dp.ready[0].img : dp.verses ? dp.verses[0].img : null);
    if (dp.hero) {                                          // one shelf only (Bag Charms): the row itself is the link
      return `<a class="acc acc--link" href="${U.col(dp.all[1])}" data-hc-el="menu-dept">${ph(thumb, 120)}<b>${esc(dp.label)}</b>${TAG.po}</a>`;
    }
    return `<details class="acc" name="bm4dept"><summary data-hc-el="menu-dept">${ph(thumb, 120)}<b>${esc(dp.label)}</b><i></i></summary><div class="acc__b">${deptBody(dp)}</div></details>`;
  }
  function drawerHtml() {
    const logo = cfg.bm4Logo ? `<img src="${esc(cfg.bm4Logo)}" alt="${esc(cfg.bm4Shop || '')}" width="120" height="24">` : `<span class="m4bar__t">${esc(cfg.bm4Shop || 'Menu')}</span>`;
    return `<div class="m4top"><div class="m4bar"><button type="button" data-bm4-close aria-label="Close menu">${ICON.x}</button>${logo}<a href="${ROOT}cart" aria-label="Cart">${ICON.bag}</a></div></div>
      <form class="msearch" action="${ROOT}search" role="search"><label>${ICON.search}<input name="q" type="search" placeholder="Search a verse or name" autocomplete="off" aria-label="Search Blessac"></label><input type="hidden" name="type" value="product"><div class="sug" role="listbox"></div></form>
      ${D.simple.map(deptRow).join('')}
      <div class="mlegend">${LEGEND}</div>
      <div class="mhelp"><a href="${U.page('track')}" data-hc-el="menu-help">Track my order</a><a href="${U.page('returns')}" data-hc-el="menu-help">Returns</a><a href="${U.page('contact')}" data-hc-el="menu-help">Contact us</a><a href="${U.page('story')}" data-hc-el="menu-help">Our Story</a></div>`;
  }
  function openDrawer() {
    if (!D) drawerEl.innerHTML = `<div class="m4top"><div class="m4bar"><button type="button" data-bm4-close aria-label="Close menu">${ICON.x}</button></div></div><p class="bm4load">Loading…</p>`;
    drawer.open = true;
    drawerEl.hidden = false;
    document.documentElement.classList.add('bm4-lock');
    if (btn) btn.setAttribute('aria-expanded', 'true');
    load().then(() => {
      if (!drawer.open) return;
      drawerEl.innerHTML = drawerHtml(); drawerEl.scrollTop = 0; wireSearch(drawerEl);
      const f = drawerEl.querySelector('[data-bm4-close]'); if (f) f.focus({ preventScroll: true, focusVisible: false });
    }).catch(() => { if (drawer.open) drawerEl.querySelector('.bm4load').textContent = 'Could not load the menu. Please check your connection and try again.'; });
  }
  function closeDrawer() {
    if (!drawer.open) return;
    drawer.open = false; drawerEl.hidden = true;
    document.documentElement.classList.remove('bm4-lock');
    if (btn) { btn.setAttribute('aria-expanded', 'false'); btn.focus({ preventScroll: true }); }
  }
  if (btn && drawerEl) {
    btn.addEventListener('pointerdown', () => load().catch(() => {}), { once: true });
    btn.addEventListener('click', () => (drawer.open ? closeDrawer() : openDrawer()));
    drawerEl.addEventListener('click', e => {
      if (e.target.closest('[data-bm4-close]')) return closeDrawer();
      const a = e.target.closest('a[href]');
      if (a) setTimeout(closeDrawer, 400);                 // bfcache: the menu is closed when the shopper comes back
    });
    /* one department open at a time (browsers without <details name> get the same behaviour here) */
    drawerEl.addEventListener('toggle', e => {
      const d = e.target;
      if (!d.matches || !d.matches('details.acc') || !d.open) return;
      drawerEl.querySelectorAll('details.acc[open]').forEach(o => { if (o !== d) o.open = false; });
      requestAnimationFrame(() => { const top = d.getBoundingClientRect().top; if (top < 56) drawerEl.scrollBy({ top: top - 64 }); });
    }, true);
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && drawer.open) closeDrawer(); });
    window.addEventListener('pageshow', e => { if (e.persisted) closeDrawer(); });
  }

  /* ---------- shared ---------- */
  document.addEventListener('click', e => {
    if (!e.target.closest('.msearch')) document.querySelectorAll('.bm4 .sug.is-open').forEach(x => x.classList.remove('is-open'));
  });
  /* Enter in the menu search box opens the store's results page; an empty box does nothing. */
  document.addEventListener('submit', e => {
    const f = e.target.closest('.bm4 form[role=search]');
    if (f && !(f.querySelector('input[name=q]').value || '').trim()) e.preventDefault();
  });

  /* warm the data while the browser is idle, so the first hover is instant */
  const idle = window.requestIdleCallback || (fn => setTimeout(fn, 2500));
  window.addEventListener('load', () => idle(() => load().catch(() => {}), { timeout: 4000 }), { once: true });
}
